import './listChildObjects.tpl.html';

angular
  .module('shared.listChildObjects', [])
  .directive('sbsfListChildObjects', directive)
  .controller('ListChildObjectsCtrl', ['$scope', controller]);

/**
 * Directive to render object's child records
 * @param {object} RecursionHelper
 * @return {object}
 */
function directive(RecursionHelper) {
  return {
    controller: 'ListChildObjectsCtrl',
    templateUrl: 'shared/listChildObjects/listChildObjects.tpl.html',
    restrict: 'E',
    scope: {
      records: '=',
      isGroupRecords: '=',
      onLink: '&'
    },
    compile: function (element) {
      return RecursionHelper.compile(element, function (scope) {
        scope.onLink();
      });
    }
  };
}

/**
 * ListChildObjects directive controller
 *
 * @param {object} $scope
 */
function controller($scope) {
  const showChildrenMap = {};

  $scope.model = {
    sobjectNameList: [],
    filteredList: [],
    recordsGroupBySobjectName: {},
    showAllChildren: false
  };

  $scope.isShowChildren = function (index) {
    return !!showChildrenMap[index];
  };

  $scope.showOrHideChildren = function (index) {
    showChildrenMap[index] = !$scope.isShowChildren(index);
  };

  $scope.$watch('records', function () {
    if ($scope.records) {
      const selectedRecords = $scope.records.filter((record) => record.isSelected);
      if (selectedRecords.length) {
        $scope.model.filteredList = selectedRecords;
      } else {
        $scope.model.filteredList = $scope.records;
        $scope.model.showAllChildren = true;
      }
      if ($scope.isGroupRecords) {
        $scope.model.sobjectNameList = $scope.groupRecordsBySobjectName();
      }
    }
  });

  $scope.groupRecordsBySobjectName = function () {
    $scope.model.recordsGroupBySobjectName = _.groupBy($scope.model.filteredList, 'sobjectName');
    return Object.keys($scope.model.recordsGroupBySobjectName);
  };
}
